var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const state = new Map();
/**
 * 本地缓存api数据
 * @description 将request的返回存储在内存中，并发调用不会重复请求，推荐使用symbol作为name的唯一标识，so标识需要存储在一个地方，查的时候好查
 * @export
 * @template T
 * @param {(symbol | string)} name
 * @param {T} request 请求主体，一般是个Promise
 * @param {boolean} [refresh=false] 是否刷新缓存数据
 * @return {*}  原样返回request的返回结果
 */
export function useState(name, request, refresh = false) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!state.has(name)) {
            state.set(name, {
                promise: null,
                data: null
            });
        }
        const info = state.get(name);
        if (refresh && !info.promise) {
            info.data = null;
        }
        if (info.data == null) {
            if (!info.promise) {
                info.promise = request();
            }
            try {
                info.data = yield info.promise;
            }
            finally {
                info.promise = null;
            }
        }
        return info.data;
    });
}
/**
 * 获取缓存数据
 * @template T 返回的数据结构
 * @param {symbol} name 唯一标识
 */
export function getState(name) {
    var _a;
    return (_a = state.get(name)) === null || _a === void 0 ? void 0 : _a.data;
}
/**
 * 删除缓存数据
 * @param {symbol} name
 */
export function removeState(name) {
    return state.delete(name);
}
